import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import InfoCards from "@/components/InfoCards";
import Bracket from "@/components/Bracket";
import Teams from "@/components/Teams";
import Inscripciones from "@/components/Inscripciones";
import Footer from "@/components/Footer";

const LandingPage = ({ scrollTo }) => {
  useEffect(() => {
    if (!scrollTo) return;
    const el = document.getElementById(scrollTo);
    if (!el) return;
    // Wait for layout/fonts before scrolling
    const timer = setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);
    return () => clearTimeout(timer);
  }, [scrollTo]);

  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <InfoCards />
        <Bracket />
        <Teams />
        <Inscripciones />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
